import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowRightCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-right-circle"} maskId="square-filled-radius-0-stroke-1-IconArrowRightCircle"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM17.2071 12L13 16.2071L12.2929 15.5L15.2929 12.5H7V11.5H15.2929L12.2929 8.5L13 7.79289L17.2071 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowRightCircle;
